import axios from 'axios';
import { getToken } from './hasToken';

export const setAuthToken = token => {
    if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    else
        delete axios.defaults.headers.common["Authorization"];
}

// const service = axios.create({
//     timeout: 20000 // request timeout
// });

// request interceptor
axios.interceptors.request.use(
    config => {
        config.headers["Authorization"] = "Bearer " + getToken();
        return config;
    },
    error => {
        Promise.reject(error);
    }
);